import React from 'react';
import './VideoSection.css';

const VideoSection = () => {
    return (
        <section className="video-section">
            <div className="container">
                <div className="video-wrapper">
                    <video
                        src="https://embracebeautyclinic.com/assets/EmbraceVideo.mp4"
                        className="clinic-video"
                        autoPlay
                        loop
                        muted
                        playsInline
                    />
                </div>
            </div>
        </section>
    );
};

export default VideoSection;
